export default __webpack_public_path__ + "static/media/houseBB2.0b12ec01.svg";